import React from 'react';
import { Spinner } from 'react-bootstrap';
import styles from './LoadingSpinner.module.scss';

interface ILoadingSpinnerProps {
  className?: string | undefined;
  isButtonSpinner?: boolean;
}

export default function LoadingSpinner({
  className = styles.loading,
  isButtonSpinner = false
}: ILoadingSpinnerProps) {
  return isButtonSpinner ? (
    <Spinner className={className} animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  ) : (
    <div className="h-100 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
      <Spinner className={className} animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}
